const CLICK = 'click';
const IMPRESSION = 'impression';

export const PRODUCT_LIST_IMPRESSION = {
  eid: 'prodlist.impression',
  type: IMPRESSION
};

export const PRODUCT_LIST_LOW_IN_STOCK_IMPRESSION = {
  eid: 'prodlist.low_in_stock.impression',
  type: IMPRESSION
};

export const SORT_DROPDOWN_IMPRESSION = {
  eid: 'sort.impression',
  type: IMPRESSION
};

export const SORT_DROPDOWN_DESCEND_BY_POPULARITY_CLICK = {
  eid: 'sort.descend_by_popularity.click',
  type: CLICK
};

export const SORT_DROPDOWN_DESCEND_BY_CREATED_AT_CLICK = {
  eid: 'sort.descend_by_created_at.click',
  type: CLICK
};

export const SORT_DROPDOWN_ASCEND_BY_PRICE_CLICK = {
  eid: 'sort.ascend_by_price.click',
  type: CLICK
};

export const SORT_DROPDOWN_DESCEND_BY_PRICE_CLICK = {
  eid: 'sort.descend_by_price.click',
  type: CLICK
};

export const SORT_DROPDOWN_ASCEND_BY_NAME_CLICK = {
  eid: 'sort.ascend_by_name.click',
  type: CLICK
};

export const SORT_DROPDOWN_DESCEND_BY_NAME_CLICK = {
  eid: 'sort.descend_by_name.click',
  type: CLICK
};

export const CATEGORY_LIST_CATEGORY_CLICK = {
  eid: 'category_list.category.click',
  type: CLICK
};

export const PRODUCT_LIST_PRODUCT_CLICK = {
  eid: 'prodlist.product.click',
  type: CLICK
};

export const PRODUCT_LIST_PRODUCT_SALE_PRICE_CLICK = {
  eid: 'prodlist.product.sale_price.click',
  type: CLICK
};

export const PRODUCT_LIST_LOW_IN_STOCK_CLICK = {
  eid: 'prodlist.low_in_stock.click',
  type: CLICK
};

export const PAGINATION_IMPRESSION = {
  eid: 'pagination.impression',
  type: IMPRESSION
};

export const PAGINATION_PAGE_NUMBER_CLICK = {
  eid: 'pagination.page_number.click',
  type: CLICK
};

export const PAGINATION_ARROW_CLICK = {
  eid: 'pagination.arrow.click',
  type: CLICK
};

export const PRODUCT_LIST_MORE_OPTIONS_IMPRESSION = {
  eid: 'prodlist.more_options.impression',
  type: IMPRESSION
};

export const PRODUCT_LIST_MORE_OPTIONS_CLICK = {
  eid: 'prodlist.more_options.click',
  type: CLICK
};

export const PRODUCT_LIST_SALE_PRICE_IMPRESSION = {
  eid: 'prodlist.sale_price.impression',
  type: IMPRESSION
};

export const ribbonMetricBuilder = (ribbon, ribbonOption, type) => {
  return {
    eid: `prodlist.ribbon_${ribbon}.${type}`,
    type: type,
    params: [['ribbon_option', ribbonOption]]
  };
};

export const ribbonStyleMetricBuilder = (ribbonStyle, type) => {
  return {
    eid: `prodlist.ribbon_style_${ribbonStyle}.${type}`,
    type: type
  };
};

export const PRODUCT_LIST_LIMITED_EDITION_EYEBROW_PRODUCT_IMPRESSION = {
  eid: 'prodlist.limited_edition_eyebrow.impression',
  type: IMPRESSION
};

export const PRODUCT_LIST_LIMITED_EDITION_EYEBROW_PRODUCT_CLICK = {
  eid: 'prodlist.limited_edition_eyebrow.click',
  type: CLICK
};

export const PRODUCT_LIST_FREE_SHIPPING_EYEBROW_PRODUCT_IMPRESSION = {
  eid: 'prodlist.free_shipping_eyebrow.impression',
  type: IMPRESSION
};

export const PRODUCT_LIST_FREE_SHIPPING_EYEBROW_PRODUCT_CLICK = {
  eid: 'prodlist.free_shipping_eyebrow.click',
  type: CLICK
};

export const PRODUCT_LIST_FREE_SHIPPING_AND_RETURNS_EYEBROW_PRODUCT_IMPRESSION = {
  eid: 'prodlist.free_shipping_returns_eyebrow.impression',
  type: IMPRESSION
};

export const PRODUCT_LIST_FREE_SHIPPING_AND_RETURNS_EYEBROW_PRODUCT_CLICK = {
  eid: 'prodlist.free_shipping_returns_eyebrow.click',
  type: CLICK
};

export const PRODUCT_LIST_FREE_RETURNS_EYEBROW_PRODUCT_IMPRESSION = {
  eid: 'prodlist.free_returns_eyebrow.impression',
  type: IMPRESSION
};

export const PRODUCT_LIST_FREE_RETURNS_EYEBROW_PRODUCT_CLICK = {
  eid: 'prodlist.free_returns_eyebrow.click',
  type: CLICK
};

export const PRODUCT_DETAIL_LAYOUT_1_IMPRESSION = {
  eid: 'pdp.layout_1.impression',
  type: IMPRESSION
};

export const PRODUCT_DETAIL_LAYOUT_2_IMPRESSION = {
  eid: 'pdp.layout_2.impression',
  type: IMPRESSION
};

export const PRODUCT_DETAIL_LAYOUT_3_IMPRESSION = {
  eid: 'pdp.layout_3.impression',
  type: IMPRESSION
};

export const IMAGE_THUMBNAIL_CLICK = {
  eid: 'image_thumbnail.click',
  type: CLICK
};

export const SIMILAR_PRODUCTS_IMPRESSION = {
  eid: 'similar_products.impression',
  type: IMPRESSION
};

export const SIMILAR_PRODUCTS_PRODUCT_CLICK = {
  eid: 'similar_products.product.click',
  type: CLICK
};

export const COMING_SOON_MODAL_IMPRESSION = {
  eid: 'coming_soon_modal.impression',
  type: IMPRESSION
};

export const PRODUCT_DETAIL_PAGE_ADD_TO_CART_CTA_CLICK = {
  eid: 'pdp.add_to_cart_cta.click',
  type: CLICK
};

export const PRODUCT_LIST_ADD_TO_CART_CLICK = {
  eid: 'prodlist.add_to_cart.click',
  type: CLICK
};

export const PRODUCT_DETAIL_PAGE_ADD_TO_CART_WITH_LOW_INVENTORY_CLICK = {
  eid: 'pdp.add_to_cart_cta_low_inventory.click',
  type: CLICK
};

export const PRODUCT_LIST_ADD_TO_CART_LOW_INVENTORY_CLICK = {
  eid: 'prodlist.add_to_cart_low_in_stock.click',
  type: CLICK
};

export const OUT_OF_STOCK_PRODUCT_IMPRESSION = {
  eid: 'out_of_stock_product.impression',
  type: IMPRESSION
};

export const OUT_OF_STOCK_PRODUCT_CLICK = {
  eid: 'out_of_stock_product.click',
  type: CLICK
};

export const CART_APPLE_PAY_BUTTON_IMPRESSION = {
  eid: 'cart_apple_pay_button.impression',
  type: IMPRESSION
};

export const CART_APPLE_PAY_BUTTON_CLICK = {
  eid: 'cart_apple_pay_button.click',
  type: CLICK
};

export const PDP_APPLE_PAY_BUTTON_IMPRESSION = {
  eid: 'pdp_apple_pay_button.impression',
  type: IMPRESSION
};

export const PDP_APPLE_PAY_BUTTON_CLICK = {
  eid: 'pdp_apple_pay_button.click',
  type: CLICK
};

export const CART_PAYMENT_REQUEST_BUTTON_IMPRESSION = {
  eid: 'cart_payment_request_button.impression',
  type: IMPRESSION
};

export const CART_PAYMENT_REQUEST_BUTTON_CLICK = {
  eid: 'cart_payment_request_button.click',
  type: CLICK
};

export const PDP_PAYMENT_REQUEST_BUTTON_IMPRESSION = {
  eid: 'pdp_payment_request_button.impression',
  type: IMPRESSION
};

export const PRODUCT_LIST_PAYMENT_REQUEST_BUTTON_IMPRESSION = {
  eid: 'prodlist_payment_request_button.impression',
  type: IMPRESSION
};

export const PDP_POYNT_AP_BUTTON_IMPRESSION = {
  eid: 'pdp_poynt_ap_button.impression',
  type: IMPRESSION
};

export const PRODUCT_LIST_POYNT_AP_BUTTON_IMPRESSION = {
  eid: 'prodlist_poynt_ap_button.impression',
  type: IMPRESSION
};

export const QUICK_VIEW_MODAL_POYNT_AP_BUTTON_IMPRESSION = {
  eid: 'quick_view_modal.poynt_ap_button.impression',
  type: IMPRESSION
};

export const QUICK_VIEW_MODAL_POYNT_GP_BUTTON_IMPRESSION = {
  eid: 'quick_view_modal.poynt_gp_button.impression',
  type: IMPRESSION
};

export const QUICK_VIEW_MODAL_LOW_IN_STOCK_POYNT_AP_BUTTON_IMPRESSION = {
  eid: 'quick_view_modal_low_in_stock.poynt_ap_button.impression',
  type: IMPRESSION
};

export const QUICK_VIEW_MODAL_LOW_IN_STOCK_POYNT_GP_BUTTON_IMPRESSION = {
  eid: 'quick_view_modal_low_in_stock.poynt_gp_button.impression',
  type: IMPRESSION
};

export const QUICK_VIEW_MODAL_POYNT_AP_BUTTON_CLICK = {
  eid: 'quick_view_modal.poynt_ap_button.click',
  type: CLICK
};

export const QUICK_VIEW_MODAL_POYNT_GP_BUTTON_CLICK = {
  eid: 'quick_view_modal.poynt_gp_button.click',
  type: CLICK
};

export const QUICK_VIEW_MODAL_LOW_IN_STOCK_POYNT_AP_BUTTON_CLICK = {
  eid: 'quick_view_modal_low_in_stock.poynt_ap_button.click',
  type: CLICK
};

export const QUICK_VIEW_MODAL_LOW_IN_STOCK_POYNT_GP_BUTTON_CLICK = {
  eid: 'quick_view_modal_low_in_stock.poynt_gp_button.click',
  type: CLICK
};

export const PDP_POYNT_GP_BUTTON_IMPRESSION = {
  eid: 'pdp_poynt_gp_button.impression',
  type: IMPRESSION
};

export const PRODUCT_LIST_POYNT_GP_BUTTON_IMPRESSION = {
  eid: 'prodlist_poynt_gp_button.impression',
  type: IMPRESSION
};

export const PDP_POYNT_AP_BUTTON_CLICK = {
  eid: 'pdp_poynt_ap_button.click',
  type: CLICK
};

export const PRODUCT_LIST_POYNT_AP_BUTTON_CLICK = {
  eid: 'prodlist_poynt_ap_button.click',
  type: CLICK
};

export const PDP_POYNT_GP_BUTTON_CLICK = {
  eid: 'pdp_poynt_gp_button.click',
  type: CLICK
};

export const PRODUCT_LIST_POYNT_GP_BUTTON_CLICK = {
  eid: 'prodlist_poynt_gp_button.click',
  type: CLICK
};

export const PDP_POYNT_AP_COMPLETED_IMPRESSION = {
  eid: 'pdp_poynt_ap_completed.impression',
  type: IMPRESSION
};

export const PDP_POYNT_GP_COMPLETED_IMPRESSION = {
  eid: 'pdp_poynt_gp_completed.impression',
  type: IMPRESSION
};

export const PDP_PAYMENT_REQUEST_BUTTON_CLICK = {
  eid: 'pdp_payment_request_button.click',
  type: CLICK
};

export const PRODUCT_LIST_PAYMENT_REQUEST_BUTTON_CLICK = {
  eid: 'prodlist_payment_request_button.click',
  type: CLICK
};

export const BUY_NOW_BUTTON_IMPRESSION = view => {
  return {
    eid: `${view}_buy_now_button.impression`,
    type: IMPRESSION
  };
};

export const QUICK_VIEW_MODAL_BUY_NOW_BUTTON_IMPRESSION = {
  eid: `quick_view_modal.buy_now_button.impression`,
  type: IMPRESSION
};

export const QUICK_VIEW_MODAL_LOW_IN_STOCK_BUY_NOW_BUTTON_IMPRESSION = {
  eid: `quick_view_modal_low_in_stock.buy_now_button.impression`,
  type: IMPRESSION
};

export const QUICK_VIEW_MODAL_BUY_NOW_BUTTON_CLICK = {
  eid: `quick_view_modal.buy_now_button.click`,
  type: CLICK
};

export const QUICK_VIEW_MODAL_LOW_IN_STOCK_BUY_NOW_BUTTON_CLICK = {
  eid: `quick_view_modal_low_in_stock.buy_now_button.click`,
  type: CLICK
};

export const OLS_MOBILE_CHECKOUT_BUTTONS_STICKY_FOOTER_ON_IMPRESSION = {
  eid: 'ols_mobile_checkout_buttons_sticky_footer_on.impression',
  type: IMPRESSION
};

export const OLS_MOBILE_CHECKOUT_BUTTONS_STICKY_FOOTER_OFF_IMPRESSION = {
  eid: 'ols_mobile_checkout_buttons_sticky_footer_off.impression',
  type: IMPRESSION
};

export const OLS_STICKY_FOOTER_CHECKOUT_BUTTONS_IMPRESSION = {
  eid: 'ols_sticky_footer_checkout_buttons.impression',
  type: IMPRESSION
};

export const OLS_PDP_CHECKOUT_BUTTONS_IMPRESSION = {
  eid: 'ols_pdp_checkout_buttons.impression',
  type: IMPRESSION
};

export const OLS_MOBILE_CART_CHECKOUT_BUTTONS_STICKY_FOOTER_ON_IMPRESSION = {
  eid: 'ols_mobile_cart_checkout_buttons_sticky_footer_on.impression',
  type: IMPRESSION
};

export const OLS_MOBILE_CART_CHECKOUT_BUTTONS_STICKY_FOOTER_OFF_IMPRESSION = {
  eid: 'ols_mobile_cart_checkout_buttons_sticky_footer_off.impression',
  type: IMPRESSION
};

export const OLS_MOBILE_CART_CHECKOUT_BUTTONS_STICKY_FOOTER_INELIGIBLE_IMPRESSION = {
  eid: 'ols_mobile_cart_checkout_buttons_sticky_footer_ineligible.impression',
  type: IMPRESSION
};

export const BUY_NOW_BUTTON_CLICK = view => {
  return {
    eid: `${view}_buy_now_button.click`,
    type: CLICK
  };
};

export const BUY_NOW_BUTTON_ERROR = view => {
  return {
    eid: `${view}_buy_now_button_error.impression`,
    type: IMPRESSION
  };
};

export const CART_CHECKOUT_CLICK = {
  eid: 'cart_checkout.click',
  type: CLICK
};

export const LOW_INVENTORY_IMPRESSION = {
  eid: 'pdp.low_inventory_threshold.impression',
  type: IMPRESSION
};

export const LOW_INVENTORY_ALMOST_GONE_IMPRESSION = {
  eid: 'pdp.low_inventory_almost_gone.impression',
  type: IMPRESSION
};

export const BUY_NOW_BUTTON_LOW_INVENTORY_IMPRESSION = {
  eid: 'pdp_buy_now_button_low_inventory.impression',
  type: IMPRESSION
};

export const BUY_NOW_BUTTON_LOW_INVENTORY_CLICK = view => {
  return {
    eid: `${view}_buy_now_button_low_inventory.click`,
    type: CLICK
  };
};

export const POYNT_GP_BUTTON_LOW_INVENTORY_IMPRESSION = {
  eid: 'pdp_poynt_gp_button_low_inventory.impression',
  type: IMPRESSION
};

export const POYNT_GP_BUTTON_LOW_INVENTORY_CLICK = {
  eid: 'pdp_poynt_gp_button_low_inventory.click',
  type: CLICK
};

export const POYNT_AP_BUTTON_LOW_INVENTORY_IMPRESSION = {
  eid: 'pdp_poynt_ap_button_low_inventory.impression',
  type: IMPRESSION
};

export const POYNT_AP_BUTTON_LOW_INVENTORY_CLICK = {
  eid: 'pdp_poynt_ap_button_low_inventory.click',
  type: CLICK
};

export const CART_POYNT_AP_BUTTON_IMPRESSION = {
  eid: 'cart_poynt_ap_button.impression',
  type: IMPRESSION
};

export const CART_POYNT_GP_BUTTON_IMPRESSION = {
  eid: 'cart_poynt_gp_button.impression',
  type: IMPRESSION
};

export const CART_POYNT_AP_BUTTON_CLICK = {
  eid: 'cart_poynt_ap_button.click',
  type: CLICK
};

export const CART_POYNT_GP_BUTTON_CLICK = {
  eid: 'cart_poynt_gp_button.click',
  type: CLICK
};

export const CART_POYNT_AP_COMPLETED_IMPRESSION = {
  eid: 'cart_poynt_ap_completed.impression',
  type: IMPRESSION
};

export const CART_POYNT_GP_COMPLETED_IMPRESSION = {
  eid: 'cart_poynt_gp_completed.impression',
  type: IMPRESSION
};

export const CART_VIEW_IMPRESSION = ({ loggedIn, cartSize }) => {
  return {
    eid: 'cart_view.impression',
    type: IMPRESSION,
    params: [
      ['Logged in', loggedIn],
      ['Cart size', cartSize]
    ]
  };
};

export const CART_REMOVE_ITEM_CLICK = ({ productType, beginningCartSize }) => {
  return {
    eid: 'cart_remove_item.click',
    type: CLICK,
    params: [
      ['Product type', productType],
      ['Beginning cart size', beginningCartSize]
    ]
  };
};

export const CART_ADJUST_ITEM_QTY_CLICK = ({ adjustedQty, beginningQty }) => {
  return {
    eid: 'cart_adjust_item_qty.click',
    type: CLICK,
    params: [
      ['Adjusted Qty', adjustedQty],
      ['Beginning Qty', beginningQty]
    ]
  };
};

export const CART_UPDATE_CLICK = {
  eid: 'cart_update.click',
  type: CLICK
};

export const CART_COUPON_INPUT_IMPRESSION = {
  eid: 'cart_coupon_input.impression',
  type: IMPRESSION
};

export const CART_FREE_SHIPPING_LABEL_IMPRESSION = {
  eid: 'cart_free_shipping_label.impression',
  type: IMPRESSION
};

export const CART_FREE_SHIPPING_BANNER_IMPRESSION = {
  eid: 'cart_free_shipping_banner.impression',
  type: IMPRESSION
};

export const CART_APPLY_COUPON_CLICK = ({ valid }) => {
  return {
    eid: 'cart_apply_coupon.click',
    type: CLICK,
    params: [['Valid', valid]]
  };
};

export const CART_CONTINUE_SHOPPING_CLICK = ({ beginningCartSize }) => {
  return {
    eid: 'cart_continue_shopping.click',
    type: CLICK,
    params: [['Beginning cart size', beginningCartSize]]
  };
};

export const PRODUCT_LIST_QUICK_VIEW_BUTTON_CLICK = {
  eid: 'prodlist.quick_view_button.click',
  type: CLICK
};

export const PRODUCT_LIST_SALE_PRICE_QUICK_VIEW_BUTTON_CLICK = {
  eid: 'prodlist.sale_price_quick_view_button.click',
  type: CLICK
};

export const PRODUCT_LIST_QUICK_VIEW_BUTTON_LOW_IN_STOCK_CLICK = {
  eid: 'prodlist.quick_view_button_low_in_stock.click',
  type: CLICK
};

export const PRODUCT_LIST_QUICK_VIEW_MODAL_IMPRESSION = {
  eid: 'prodlist.quick_view_modal.impression',
  type: IMPRESSION
};

export const PRODUCT_LIST_QUICK_VIEW_MODAL_LOW_IN_STOCK_IMPRESSION = {
  eid: 'prodlist.quick_view_modal_low_in_stock.impression',
  type: IMPRESSION
};

export const PRODUCT_LIST_QUICK_VIEW_MODAL_CLOSE_CLICK = {
  eid: 'prodlist.quick_view_modal_close.click',
  type: CLICK
};

export const QUICK_VIEW_MODAL_ADD_TO_CART_CLICK = {
  eid: 'quick_view_modal.add_to_cart.click',
  type: CLICK
};

export const QUICK_VIEW_MODAL_LOW_IN_STOCK_ADD_TO_CART_CLICK = {
  eid: 'quick_view_modal_low_in_stock.add_to_cart.click',
  type: CLICK
};

export const GALLERY_DETAIL_ADD_TO_CART_CLICK = {
  eid: 'gallery_detail.add_to_cart.click',
  type: CLICK
};

export const QUICK_VIEW_MODAL_VIEW_FULL_DETAILS_CLICK = {
  eid: 'quick_view_modal.view_full_details.click',
  type: CLICK
};

export const QUICK_VIEW_MODAL_LOW_IN_STOCK_VIEW_FULL_DETAILS_CLICK = {
  eid: 'quick_view_modal_low_in_stock.view_full_details.click',
  type: CLICK
};

export const SOCIAL_SHARING_C2_IMPRESSION = {
  eid: 'pdp.social_sharing.impression',
  type: IMPRESSION
};

export const SOCIAL_SHARING_FACEBOOK_CTA_CLICK = {
  eid: 'pdp.social_sharing.facebook_cta.click',
  type: CLICK
};

export const SOCIAL_SHARING_TWITTER_CTA_CLICK = {
  eid: 'pdp.social_sharing.twitter_cta.click',
  type: CLICK
};

// C1's metrics
export const SHOP_ZERO_STATE_IMPRESSION = 'SHOP_ZERO_STATE_IMPRESSION';
export const SHOP_ZERO_STATE_ADD_PRODUCT_CTA_CLICKED = 'SHOP_ZERO_STATE_ADD_PRODUCT_CTA_CLICKED';
export const SHOP_ZERO_STATE_IMPORT_PRODUCT_CTA_CLICKED =
  'SHOP_ZERO_STATE_IMPORT_PRODUCT_CTA_CLICKED';

export const BRUCE_EDIT_DIGITAL_PRODUCT_CLICK = 'BRUCE_EDIT_DIGITAL_PRODUCT_CLICK';
